<template>
  <div id="app" v-scroll="handleScroll">
    <Navbar />

    <router-view :key="$route.fullPath">
      <Home />
      <Partners />
    </router-view>

    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Home from "./components/Home.vue";
import Partners from "./components/Partners.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Navbar,
    Home,
    Partners,
    Footer,
  },

  methods: {
    handleScroll: function () {
      if (window.scrollY > 0) {
        document.querySelector("body").classList.add("scrolled");
      } else if (window.scrollY === 0) {
        document.querySelector("body").classList.remove("scrolled");
      }
    },
  },

  
};
</script>

<style>
@import "./App.css";

.scrolled #home {
  background-color: white;
  transition-duration: 0.7s;
  border-top: 20px solid black;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
</style>
